import APIController from '../core-api-controller';

export const fetchIntakesApi = (paramsObj = {}, paramsStr = '') => {
  const path = `${APIController.endpointApi}/intakes${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};
